export type AgentCardSort =
  | "modified_desc"
  | "modified_asc"
  | "activity_desc"
  | "calls_desc"
  | "success_desc"
  | "name_asc"
  | "name_desc";

export interface SortableAgentCard {
  name: string;
  modifiedAt?: string | null;
  lastActivityAt?: string | null;
  calls: number;
  successRate: number;
}

export const AGENT_CARD_SORT_OPTIONS: { value: AgentCardSort; label: string }[] = [
  { value: "modified_desc", label: "Recently modified" },
  { value: "modified_asc", label: "Oldest modified" },
  { value: "activity_desc", label: "Last call / activity" },
  { value: "calls_desc", label: "Most calls" },
  { value: "success_desc", label: "Highest success" },
  { value: "name_asc", label: "Name A-Z" },
  { value: "name_desc", label: "Name Z-A" },
];

const timestamp = (value?: string | null) => {
  const parsed = value ? new Date(value).getTime() : 0;
  return Number.isFinite(parsed) ? parsed : 0;
};

export function sortAgentCards<T extends SortableAgentCard>(items: T[], sort: AgentCardSort) {
  return [...items].sort((left, right) => {
    let result = 0;
    if (sort === "modified_desc") result = timestamp(right.modifiedAt) - timestamp(left.modifiedAt);
    if (sort === "modified_asc") result = timestamp(left.modifiedAt) - timestamp(right.modifiedAt);
    if (sort === "activity_desc") result = timestamp(right.lastActivityAt) - timestamp(left.lastActivityAt);
    if (sort === "calls_desc") result = right.calls - left.calls;
    if (sort === "success_desc") result = right.successRate - left.successRate;
    if (sort === "name_asc") result = left.name.localeCompare(right.name);
    if (sort === "name_desc") result = right.name.localeCompare(left.name);
    return result || left.name.localeCompare(right.name);
  });
}
